import { render, staticRenderFns } from "./manualBackups.vue?vue&type=template&id=2e6ef4f6&scoped=true&"
import script from "./manualBackups.vue?vue&type=script&lang=js&"
export * from "./manualBackups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6ef4f6",
  null
  
)

export default component.exports